import React from 'react';

const EyeIcon: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 4.5C7 4.5 2.73 8.11 1 12C2.73 15.89 7 19.5 12 19.5C17 19.5 21.27 15.89 23 12C21.27 8.11 17 4.5 12 4.5Z"
        fill="#A6A4B5"
      />
      <circle cx="12" cy="12" r="5" fill="white" />
      <circle cx="12" cy="12" r="3" fill="#1B143F" />
    </svg>
  );
};

export default EyeIcon;

